module.exports = {
	"currentYear": "2018",
	"years": [
		"2017",
		"2018",
		"2019"
	],
	"defaultWorkingHours": 40,
	"workingWeeks": 52,
	"workingDays": 260,
	"nominalExpenseRates": {
		"2016": 0.2,
		"2017": 0.2,
		"2018": 0.3,
		"2019": 0.3
	},
	"payrollTax": {
		"2017": [
			{
				"bracket": 1,
				"min": 0,
				"rate": 0.2
			}
		],
		"2018": [
			{
				"bracket": 1,
				"min": 0,
				"max": 8021.34,
				"rate": 0.16
			},
			{
				"bracket": 2,
				"min": 8021.35,
				"max": 20400,
				"rate": 0.27
			},
			{
				"bracket": 3,
				"min": 20400.01,
				"max": 48000,
				"rate": 0.34
			},
			{
				"bracket": 4,
				"min": 48000.01,
				"max": 70907.2,
				"rate": 0.39
			},
			{
				"bracket": 4,
				"min": 70907.21,
				"rate": 0.5
			}
		],
		"2019": [
			{
				"bracket": 1,
				"min": 0,
				"max": 8021.34,
				"rate": 0.16
			},
			{
				"bracket": 2,
				"min": 8021.35,
				"max": 20400,
				"rate": 0.27
			},
			{
				"bracket": 3,
				"min": 20400.01,
				"max": 48000,
				"rate": 0.34
			},
			{
				"bracket": 4,
				"min": 48000.01,
				"max": 70907.2,
				"rate": 0.39
			},
			{
				"bracket": 4,
				"min": 70907.21,
				"rate": 0.5
			}
		]
	},
	"socialPercent": {
		"2017": [
			{
				"bracket": 1,
				"min": 0,
				"rate": 0.382
			}
		],
		"2018": [
			{
				"bracket": 1,
				"min": 0,
				"rate": 0.382
			}
		],
		"2019": [
			{
				"bracket": 1,
				"min": 0,
				"rate": 0.382
			}
		]
	},
	"generalCredit": {
		"2017": [
			{
				"bracket": 1,
				"min": 0,
				"rate": 0
			}
		],
		"2018": [
			{
				"bracket": 1,
				"min": 0,
				"max": 11166.37,
				"rate": 6519.82
			},
			{
				"bracket": 2,
				"min": 11166.38,
				"max": 12570.89,
				"rate": 4418.64
			},
			{
				"bracket": 3,
				"min": 12570.9,
				"rate": 3302.7
			}
		],
		"2019": [
			{
				"bracket": 1,
				"min": 0,
				"max": 11166.37,
				"rate": 6519.82
			},
			{
				"bracket": 2,
				"min": 11166.38,
				"max": 12570.89,
				"rate": 4418.64
			},
			{
				"bracket": 3,
				"min": 12570.9,
				"rate": 3302.7
			}
		]
	},
	"labourCredit": {
		"2017": [
			{
				"bracket": 1,
				"min": 0,
				"rate": 0
			}
		],
		"2018": [
			{
				"bracket": 1,
				"min": 0,
				"rate": 0
			}
		],
		"2019": [
			{
				"bracket": 1,
				"min": 0,
				"rate": 0
			}
		]
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./data.json
 ** module id = 7
 ** module chunks = 0
 **/